import { openDB, DBSchema } from 'idb';
import { firestore } from '../../config/fbInit';


interface MyDB extends DBSchema {
    currentUser: {
        value: {
            userKey: string;
            email: string;
            name: string;
            permissions: string;
            tags: string;
        };
        key: string;
    };

}
interface ICurrentUser {
    email: string;
    isSuper: boolean;
    name: string
    permissions: string;
    tags: string;
    themeIndex: number;
}
const getData = (uid: string) => {
    const ref = firestore.collection("users").doc(uid)
    return ref.get()
}
export async function idbLogin(uid: string) {
    const currentUser = await getData(uid)
        .then(doc => {
            const user = doc.data() as ICurrentUser
            return user
        })
    //console.log(currentUser)
    const db = await openDB<MyDB>('Crs-Information-IDB', 2);
    const tx = db.transaction('currentUser', 'readwrite');
    const store = tx.objectStore('currentUser');
    const item = {
        userKey: "userc9b11aaf-e560-4b3c-b7a8-1ae9e9837b60",
        email: currentUser.email,
        name: currentUser.name,
        permissions: currentUser.permissions,
        tags: currentUser.tags
    };
    //console.log("item :", item)
    store.put(item);
    return tx.oncomplete = (event) => {
        // console.log(event)
    }
}

export async function idbLogout() {
    //console.log(currentUser)
    const db = await openDB<MyDB>('Crs-Information-IDB', 2);
    const tx = db.transaction('currentUser', 'readwrite');
    const store = tx.objectStore('currentUser');
    const item = {
        userKey: "userc9b11aaf-e560-4b3c-b7a8-1ae9e9837b60",
        email: "default@crs.com",
        name: "default",
        permissions: "00,00,00,00,00,00,00,00,10,00,00,00,00,00,00",
        tags: "0,0,0,0,0,0,0,0"
    };
    //console.log("item :", item)
    store.put(item);
    return tx.oncomplete = (event) => {
        // console.log(event)
    }
}